import type { TourConfig } from '../../types/tour.types'

// CRM Setup page. Anchors are `data-tour` attributes on the view (added alongside this tour).
// The mapping and refresh columns only render once a CRM is connected and supports them,
// so those steps are optional and skip silently when absent.
const crmSetupTour: TourConfig = {
  id: 'crm-setup',
  title: 'Push leads straight to your CRM',
  module: 'Settings',
  routeName: 'CrmSetup',
  order: 16,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Connect your CRM once, export in one click',
      body: 'Link TAMI to **HubSpot, Salesforce, Pipedrive** and more. Once connected, every company and contact you find can be pushed to your CRM — no copy-paste, no duplicates.',
    },
    {
      id: 'connect',
      target: '[data-tour="crm-connect"]',
      placement: 'bottom',
      title: 'Choose and connect your CRM',
      body: 'Pick your CRM here and **authorize the connection**. This is the starting point — once it is live, the mapping and sync options unlock automatically.',
    },
    {
      id: 'mapping',
      target: '[data-tour="crm-mapping"]',
      placement: 'bottom',
      // Only shown once a CRM that supports field mapping is connected.
      optional: true,
      title: 'Map your fields',
      body: 'Decide **how TAMI data lands in your CRM** — match each field to the right property so exported records slot into your existing workflow cleanly.',
    },
    {
      id: 'refresh',
      target: '[data-tour="crm-refresh"]',
      placement: 'bottom',
      // Only shown for CRMs that support scheduled refresh (e.g. Salesforce).
      optional: true,
      title: 'Keep records fresh',
      body: 'Turn on **automatic refresh** to keep companies and contacts in your CRM up to date with the latest TAMI data, without lifting a finger.',
    },
  ],
}

export default crmSetupTour
